module.exports = __webpack_public_path__ + "img/stepvan_parked.451847bc.svg";